<template>
  <div class="contain">
    <div class="title">基础用法</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="goToJump('basic')"
        ><span class="text">进入地址编辑页</span></van-button
      >
    </div>

    <div class="title">表单项宽度和文本对齐方式</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="goToJump('label')"
        ><span class="text">进入地址编辑页</span></van-button
      >
    </div>

    <div class="title">输入框文本对齐方式</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="goToJump('input')"
        ><span class="text">进入地址编辑页</span></van-button
      >
    </div>

    <div class="title">按钮宽度、背景颜色和文案</div>
    <div class="wrapper top">
      <van-button
        type="info"
        :round="showRound"
        @click="goToJump('buttonStyle')"
        ><span class="text">进入地址编辑页</span></van-button
      >
    </div>

    <div class="title">二次确认弹窗</div>
    <div class="wrapper top">
      <van-button
        type="info"
        :round="showRound"
        @click="goToJump('seconaryConfirmation')"
        ><span class="text">增加二次确认弹窗</span></van-button
      >
    </div>
    <div class="wrapper top">
      <van-button
        type="info"
        :round="showRound"
        @click="goToJump('noSeconaryConfirmation')"
        ><span class="text">取消二次确认弹窗</span></van-button
      >
    </div>

    <div class="title">可增加列表信息</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="goToJump('isExtra')"
        ><span class="text">进入地址编辑页</span></van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddressInputDemo',
  data() {
    return {
      showRound: true,
    }
  },
  methods: {
    goToJump(value) {
      this.$router.push({
        path: '/addressEditDemo',
        query: {
          type: value,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.contain {
  width: 100%;
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 30px;
  .title {
    padding-top: 30px;
    margin-left: 20px;
    font-size: 14px;
    color: rgba(69, 90, 100, 0.6);
  }
  .btn {
    width: 50px;
    height: 30px;
    background-color: cornflowerblue;
  }
  .top {
    margin-top: 15px;
  }
  .wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .text {
      color: rgb(200, 201, 204);
    }
  }
}
.van-button--info {
  width: 90%;
  /* height: 44px; */
  color: #000000;
  background-color: #ffffff;
  border: none;
  border-radius: 45px;
}
</style>
